import script from "./Web.vue?vue&type=script&setup=true&lang=ts"
export * from "./Web.vue?vue&type=script&setup=true&lang=ts"

import "./Web.vue?vue&type=style&index=0&id=3c75c572&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c75c572"]])

export default __exports__